import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { MemberContractsReportData } from "../types";

export const useMemberContractsReportData = () => {
  const data = useSelector<StoreType, MemberContractsReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.memberContracts.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
